var map = {
	"./0.png": "zZ1z",
	"./1.png": "LOA1",
	"./10.png": "rhId",
	"./11.png": "RKxq",
	"./12.png": "FUCY",
	"./13.png": "A34k",
	"./14.png": "pUR1",
	"./15.png": "dND5",
	"./16.png": "Zz0w",
	"./2.png": "NKGv",
	"./3.png": "LHqX",
	"./4.png": "+TIe",
	"./5.png": "2Pfm",
	"./6.png": "bvch",
	"./7.png": "y4L6",
	"./8.png": "I6fH",
	"./9.png": "E2RZ",
	"./Logo-Blanco.png": "b+nt",
	"./Logo-digitactil.png": "Slue",
	"./Viewmed-ClaveProfesional.png": "PLTv",
	"./abeja.png": "nvAn",
	"./bg-inmunizations-bb.png": "3MK/",
	"./clientes/cliente-1.png": "jaMU",
	"./clientes/cliente-2.png": "+q5D",
	"./clientes/cliente-3.png": "k5Yl",
	"./clientes/cliente-4.png": "jrik",
	"./clientes/cliente-5.png": "EvT2",
	"./clientes/cliente-6.png": "eSsV",
	"./en.png": "1wet",
	"./es.png": "/S0K",
	"./flags/Abkhazia.png": "kKUH",
	"./flags/Afghanistan.png": "RD/O",
	"./flags/Aland.png": "WQUe",
	"./flags/Albania.png": "Pd7q",
	"./flags/Algeria.png": "cxme",
	"./flags/American-Samoa.png": "CI1o",
	"./flags/Andorra.png": "3f0a",
	"./flags/Angola.png": "+pyC",
	"./flags/Anguilla.png": "ziSF",
	"./flags/Antarctica.png": "/VGC",
	"./flags/Antigua-and-Barbuda.png": "6/C7",
	"./flags/Argentina.png": "Nikt",
	"./flags/Armenia.png": "1ErE",
	"./flags/Aruba.png": "35hK",
	"./flags/Australia.png": "yDN8",
	"./flags/Austria.png": "lHKN",
	"./flags/Azerbaijan.png": "0oS5",
	"./flags/Bahamas.png": "l0vA",
	"./flags/Bahrain.png": "h67n",
	"./flags/Bangladesh.png": "iZqo",
	"./flags/Barbados.png": "1w6J",
	"./flags/Basque-Country.png": "+B03",
	"./flags/Belarus.png": "oLaq",
	"./flags/Belgium.png": "G1/L",
	"./flags/Belize.png": "YPjk",
	"./flags/Benin.png": "9ZVx",
	"./flags/Bermuda.png": "ZXKb",
	"./flags/Bhutan.png": "pM17",
	"./flags/Bolivia.png": "EYzR",
	"./flags/Bosnia-and-Herzegovina.png": "F6HW",
	"./flags/Botswana.png": "/sAW",
	"./flags/Brazil.png": "FTHk",
	"./flags/British-Antarctic-Territory.png": "fBFD",
	"./flags/British-Virgin-Islands.png": "+Plt",
	"./flags/Brunei.png": "S2nf",
	"./flags/Bulgaria.png": "iAgY",
	"./flags/Burkina-Faso.png": "w/HP",
	"./flags/Burundi.png": "5+eM",
	"./flags/Cambodia.png": "39sZ",
	"./flags/Cameroon.png": "BZaC",
	"./flags/Canada.png": "JCav",
	"./flags/Canary-Islands.png": "3yn2",
	"./flags/Cape-Verde.png": "RxKK",
	"./flags/Cayman-Islands.png": "zhwm",
	"./flags/Central-African-Republic.png": "hn9R",
	"./flags/Chad.png": "v5EX",
	"./flags/Chile.png": "WGg7",
	"./flags/China.png": "DdT0",
	"./flags/Christmas-Island.png": "1tBR",
	"./flags/Cocos-Keeling-Islands.png": "dTRi",
	"./flags/Colombia.png": "IbTm",
	"./flags/Commonwealth.png": "9p0u",
	"./flags/Comoros.png": "7Efo",
	"./flags/Cook-Islands.png": "/zpW",
	"./flags/Costa-Rica.png": "M7cX",
	"./flags/Cote-dIvoire.png": "DBYu",
	"./flags/Croatia.png": "XMnw",
	"./flags/Cuba.png": "3JgT",
	"./flags/Curacao.png": "UmQn",
	"./flags/Cyprus.png": "28Nl",
	"./flags/Czech-Republic.png": "P8Vc",
	"./flags/Democratic-Republic-of-the-Congo.png": "eFWf",
	"./flags/Denmark.png": "lGAZ",
	"./flags/Djibouti.png": "TIGS",
	"./flags/Dominica.png": "RzU3",
	"./flags/Dominican-Republic.png": "RElN",
	"./flags/East-Timor.png": "ZjgG",
	"./flags/Ecuador.png": "ekXE",
	"./flags/Egypt.png": "RLZj",
	"./flags/El-Salvador.png": "Rosp",
	"./flags/England.png": "FaXu",
	"./flags/Equatorial-Guinea.png": "ZoY1",
	"./flags/Eritrea.png": "KhI2",
	"./flags/Estonia.png": "wzUM",
	"./flags/Ethiopia.png": "xL+F",
	"./flags/European-Union.png": "GUJi",
	"./flags/Falkland-Islands.png": "pKkF",
	"./flags/Faroes.png": "y6vj",
	"./flags/Fiji.png": "kAQp",
	"./flags/Finland.png": "w5Ij",
	"./flags/France.png": "sADJ",
	"./flags/French-Polynesia.png": "pBio",
	"./flags/French-Southern-Territories.png": "SISM",
	"./flags/Gabon.png": "cyJX",
	"./flags/Gambia.png": "q6/r",
	"./flags/Georgia.png": "lmpj",
	"./flags/Germany.png": "mNd9",
	"./flags/Ghana.png": "Wvpu",
	"./flags/Gibraltar.png": "BDM2",
	"./flags/GoSquared.png": "zuXM",
	"./flags/Greece.png": "mNCz",
	"./flags/Greenland.png": "EqGz",
	"./flags/Grenada.png": "QLan",
	"./flags/Guam.png": "suh5",
	"./flags/Guatemala.png": "77vP",
	"./flags/Guernsey.png": "lZJU",
	"./flags/Guinea-Bissau.png": "eIad",
	"./flags/Guinea.png": "5T+X",
	"./flags/Guyana.png": "/R9c",
	"./flags/Haiti.png": "+Cff",
	"./flags/Honduras.png": "V4sH",
	"./flags/Hong-Kong.png": "2lJm",
	"./flags/Hungary.png": "DIRy",
	"./flags/Iceland.png": "HS+z",
	"./flags/India.png": "jVcK",
	"./flags/Indonesia.png": "M+fJ",
	"./flags/Iran.png": "2QOx",
	"./flags/Iraq.png": "b+67",
	"./flags/Ireland.png": "8s0l",
	"./flags/Isle-of-Man.png": "5OU8",
	"./flags/Israel.png": "Uk31",
	"./flags/Italy.png": "zYN4",
	"./flags/Jamaica.png": "lOeU",
	"./flags/Japan.png": "bVS2",
	"./flags/Jersey.png": "IGgi",
	"./flags/Jordan.png": "/wRj",
	"./flags/Kazakhstan.png": "S6ZC",
	"./flags/Kenya.png": "dGR3",
	"./flags/Kiribati.png": "LVQv",
	"./flags/Kosovo.png": "0765",
	"./flags/Kuwait.png": "tnmt",
	"./flags/Kyrgyzstan.png": "DVKX",
	"./flags/Laos.png": "yQdh",
	"./flags/Latvia.png": "Lp5r",
	"./flags/Lebanon.png": "zq4E",
	"./flags/Lesotho.png": "eil4",
	"./flags/Liberia.png": "epK6",
	"./flags/Libya.png": "w5Yi",
	"./flags/Liechtenstein.png": "Mr53",
	"./flags/Lithuania.png": "SWeA",
	"./flags/Luxembourg.png": "jsR/",
	"./flags/Macau.png": "AAtC",
	"./flags/Macedonia.png": "NJGn",
	"./flags/Madagascar.png": "e7Kf",
	"./flags/Malawi.png": "2Tu5",
	"./flags/Malaysia.png": "ko6Q",
	"./flags/Maldives.png": "PT6a",
	"./flags/Mali.png": "i1Z1",
	"./flags/Malta.png": "xWN6",
	"./flags/Mars.png": "R020",
	"./flags/Marshall-Islands.png": "8bNB",
	"./flags/Martinique.png": "iDF6",
	"./flags/Mauritania.png": "+xvK",
	"./flags/Mauritius.png": "gR7+",
	"./flags/Mayotte.png": "5pNP",
	"./flags/Mexico.png": "s6IB",
	"./flags/Micronesia.png": "L2Iz",
	"./flags/Moldova.png": "Tccf",
	"./flags/Monaco.png": "3ciO",
	"./flags/Mongolia.png": "CSGM",
	"./flags/Montenegro.png": "ZGaf",
	"./flags/Montserrat.png": "M/Le",
	"./flags/Morocco.png": "oKZl",
	"./flags/Mozambique.png": "mklt",
	"./flags/Myanmar.png": "sdNW",
	"./flags/NATO.png": "XXBf",
	"./flags/Nagorno-Karabakh.png": "Oc6q",
	"./flags/Namibia.png": "D8+n",
	"./flags/Nauru.png": "BSMu",
	"./flags/Nepal.png": "vB2M",
	"./flags/Netherlands-Antilles.png": "p5HI",
	"./flags/Netherlands.png": "E+CU",
	"./flags/New-Caledonia.png": "xoZq",
	"./flags/New-Zealand.png": "xgIA",
	"./flags/Nicaragua.png": "uM74",
	"./flags/Niger.png": "vqnU",
	"./flags/Nigeria.png": "trAH",
	"./flags/Niue.png": "2HIX",
	"./flags/Norfolk-Island.png": "Jr/A",
	"./flags/North-Korea.png": "NvYk",
	"./flags/Northern-Cyprus.png": "LFvs",
	"./flags/Northern-Mariana-Islands.png": "A+oh",
	"./flags/Norway.png": "i9Ik",
	"./flags/Olympics.png": "qqAj",
	"./flags/Oman.png": "V4X5",
	"./flags/Pakistan.png": "3iZJ",
	"./flags/Palau.png": "KDtp",
	"./flags/Palestine.png": "ScAL",
	"./flags/Panama.png": "QZHf",
	"./flags/Papua-New-Guinea.png": "UsYd",
	"./flags/Paraguay.png": "8MbD",
	"./flags/Peru.png": "ILyU",
	"./flags/Philippines.png": "ZTKp",
	"./flags/Pitcairn-Islands.png": "I2hW",
	"./flags/Poland.png": "+Rzk",
	"./flags/Portugal.png": "Yfyr",
	"./flags/Puerto-Rico.png": "HVo5",
	"./flags/Qatar.png": "0o9a",
	"./flags/Red-Cross.png": "rx7G",
	"./flags/Republic-of-the-Congo.png": "dmHV",
	"./flags/Romania.png": "6lWR",
	"./flags/Russia.png": "qXau",
	"./flags/Rwanda.png": "cqyz",
	"./flags/Saint-Barthelemy.png": "SslU",
	"./flags/Saint-Helena.png": "oQ6n",
	"./flags/Saint-Kitts-and-Nevis.png": "96a/",
	"./flags/Saint-Lucia.png": "MpZN",
	"./flags/Saint-Martin.png": "Rx//",
	"./flags/Saint-Vincent-and-the-Grenadines.png": "qdeo",
	"./flags/Samoa.png": "778Y",
	"./flags/San-Marino.png": "Uc7U",
	"./flags/Sao-Tome-and-Principe.png": "xes2",
	"./flags/Saudi-Arabia.png": "8J7d",
	"./flags/Scotland.png": "1W8X",
	"./flags/Senegal.png": "v/nh",
	"./flags/Serbia.png": "pCvi",
	"./flags/Seychelles.png": "vKWb",
	"./flags/Sierra-Leone.png": "EeIk",
	"./flags/Singapore.png": "V2ld",
	"./flags/Slovakia.png": "uSmG",
	"./flags/Slovenia.png": "m/1c",
	"./flags/Solomon-Islands.png": "qhOR",
	"./flags/Somalia.png": "txTS",
	"./flags/Somaliland.png": "uBm9",
	"./flags/South-Africa.png": "lc2g",
	"./flags/South-Georgia-and-the-South-Sandwich-Islands.png": "1xYr",
	"./flags/South-Korea.png": "pkob",
	"./flags/South-Ossetia.png": "bV8b",
	"./flags/South-Sudan.png": "DY6e",
	"./flags/Spain.png": "LBGR",
	"./flags/Sri-Lanka.png": "RV82",
	"./flags/Sudan.png": "Oqtn",
	"./flags/Suriname.png": "ONJU",
	"./flags/Swaziland.png": "7KYi",
	"./flags/Sweden.png": "I9mj",
	"./flags/Switzerland.png": "1Dm2",
	"./flags/Syria.png": "y+Dg",
	"./flags/Taiwan.png": "1//f",
	"./flags/Tajikistan.png": "mNk3",
	"./flags/Tanzania.png": "csX+",
	"./flags/Thailand.png": "tJIu",
	"./flags/Togo.png": "9L7t",
	"./flags/Tokelau.png": "shM/",
	"./flags/Tonga.png": "1gmT",
	"./flags/Trinidad-and-Tobago.png": "NpZI",
	"./flags/Tunisia.png": "33AM",
	"./flags/Turkey.png": "jTi0",
	"./flags/Turkmenistan.png": "72PN",
	"./flags/Turks-and-Caicos-Islands.png": "yisL",
	"./flags/Tuvalu.png": "kjzV",
	"./flags/US-Virgin-Islands.png": "hIdP",
	"./flags/Uganda.png": "CDmj",
	"./flags/Ukraine.png": "TEOy",
	"./flags/United-Arab-Emirates.png": "aK3T",
	"./flags/United-Kingdom.png": "gkSi",
	"./flags/United-Nations.png": "MK44",
	"./flags/United-States.png": "f2mT",
	"./flags/Unknown.png": "BkQx",
	"./flags/Uruguay.png": "DJ1F",
	"./flags/Uzbekistan.png": "AK1Q",
	"./flags/Vanuatu.png": "NKat",
	"./flags/Vatican.png": "MGc2",
	"./flags/Venezuela.png": "QeI0",
	"./flags/Vietnam.png": "FClX",
	"./flags/Wales.png": "ydJz",
	"./flags/Wallis-And-Futuna.png": "dyol",
	"./flags/Western-Sahara.png": "jXxz",
	"./flags/Yemen.png": "Wm0P",
	"./flags/Zambia.png": "pA+H",
	"./flags/Zimbabwe.png": "opzd",
	"./icon_iso.png": "RzDW",
	"./icon_zip.png": "/vm7",
	"./image.png": "G71L",
	"./jvectormaps.png": "cdEv",
	"./logo-ViewmedDigitactil-en.png": "BS7h",
	"./logo-ViewmedDigitactil-es.png": "0zHw",
	"./logo-ViewmedDigitactilGris-en.png": "MvTY",
	"./logo-ViewmedDigitactilGris-es.png": "kE8v",
	"./logo-facebook.png": "i4kn",
	"./logo-instagram.png": "4gRb",
	"./logo-linkedin.png": "zWQu",
	"./logo-twitter.png": "v0Vb",
	"./logo-viewmed.png": "xsIk",
	"./mano.png": "QUAc",
	"./medicos.png": "AEQ6",
	"./oso.png": "PzTb",
	"./pacientes.png": "ASLp",
	"./social/Facebook-icon.png": "NQb5",
	"./social/Linkedin-icon.png": "SCWG",
	"./social/Twitter-icon.png": "ebEl",
	"./social/Whatsapp-icon.png": "Lahf",
	"./social/email-icon.png": "/eIY",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - blue/blue-on-dark.png": "v/cc",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - blue/blue-on-dark@2x.png": "wcOE",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - blue/blue-on-dark@3x.png": "6yC5",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - blue/blue-on-light.png": "EMDB",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - blue/blue-on-light@2x.png": "ofnv",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - blue/blue-on-light@3x.png": "csq3",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - gray/light-on-dark.png": "bEPM",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - gray/light-on-dark@2x.png": "eENI",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - gray/light-on-dark@3x.png": "7PL4",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - gray/light-on-light.png": "81Wa",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - gray/light-on-light@2x.png": "o6/o",
	"./stripe/Stripe-Connect-button/Stripe Connect button/PNG button - gray/light-on-light@3x.png": "fPES",
	"./stripe/blue-on-dark.png": "v0mp",
	"./tanamo.png": "/Upv",
	"./testimonial_img2.png": "bF45",
	"./vuetify.png": "Ff1D"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zfj7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.png$
// module id = zfj7
// module chunks = 0